export const introConstant = {
  checklistItemsAmaze: {
    transfers: 'Have no pending transfers or refunds',
    instaPoints: 'Redeem any InstaPoints you may have',
    amazeWallet: 'Withdraw any funds in your amaze wallet'
  },
  checklistItemsNonAmaze: {
    transfers: 'Have no pending transfers or refunds',
    instaPoints: 'Redeem any InstaPoints you may have',
    receipts: 'Download your transaction receipts.'
  },
  checklistTitle: 'Before closing your account, please make sure you:',
  description: "We're sorry to see you go.",
  raiseTicketCta: 'Raise a ticket',
  startCta: 'Continue',
  title: 'Close account',
  needHelp: 'Need help?',
  needHelpDescription: `Raise a ticket and we'll help you sort it out.`,
  amazeWarning: `Once your account is closed, you won't be able to view past 
  transactions. Your amaze card will also be deactivated.`,
  nonAmazeWarning: `Once your account is closed, you won't be able to
   view your account details or past transactions.`
};

export const closedConstant = {
  cta: 'Got it',
  needHelpTitle: 'Need some help?',
  needHelpDescription:
    'Go to the app or website login screen, tap I have trouble logging in and raise a ticket within the next 6 months.',
  message: "Your account has been successfully closed. We're sorry to see you go.",
  reRegisterTitle: 'Want to use Instarem again?',
  reRegisterMessage: "Sign up anytime, we'd love to welcome you back.",
  supportMessage: `If you need any details related to your account,
     you can raise a support request from the login screen by selecting 
     "I have trouble logging in." Our customer support team will reach out to you via email.
      This option will be available for up to 6 months from now.`,
  title: 'Your account has been closed'
};

export const reasonConstant = {
  confirmCheckbox: `I confirm that I want to close my account and understand that this can't be undone.`,
  confirmCheckboxAmazeCustomer: `I confirm that I want to close my account and deactivate my amaze card,
   and understand that this can't be undone.`,
  options: {
    noLongerUsing: 'No longer using the service',
    movedCountry: 'Moved out of country',
    incorrectCountry: 'Registered with the wrong country',
    other: 'Other'
  },
  otherPlaceholder: 'Type here',
  submit: 'Submit',
  title: "Tell us why you're leaving"
};

export const popups = {
  amlHit: {
    description:
      "Please raise a ticket and we'll help you resolve this before closing your account.",
    primaryCta: 'Raise a ticket',
    title: "We can't close your account right now"
  },
  negativeBalance: {
    description:
      'Add funds to reach {{minAmount}} {{currency}}, then withdraw your balance before closing your account.',
    primaryCta: 'Raise a ticket',
    title: 'Negative wallet balance'
  },
  transferInProgress: {
    description:
      "Your transfer or refund is still underway. You can close your account once it's completed.",
    primaryCta: 'View details',
    title: 'Transfer in progress'
  },
  unresolvedDispute: {
    description:
      "You have an open amaze card dispute. Please wait until it's resolved before closing your account.",
    primaryCta: 'View details',
    title: 'Unresolved dispute'
  },
  walletLessThanOne: {
    description:
      'Add funds to reach {{minAmount}} {{currency}}, then withdraw your balance before closing your account.',
    primaryCta: 'Go to wallet',
    title: 'Wallet withdrawal required'
  },
  walletWithdraw: {
    description: 'Please withdraw your unused funds before closing your account.',
    primaryCta: 'Go to wallet',
    title: 'Wallet balance available'
  }
};

export const CLOSE_ACCOUNT_CMS_LOADING = 'CLOSE_ACCOUNT_CMS_LOADING';
export const CLOSE_ACCOUNT_CMS_LOADED = 'CLOSE_ACCOUNT_CMS_LOADED';
export const CLOSE_ACCOUNT_SET_STEP = 'CLOSE_ACCOUNT_SET_STEP';
export const CLOSE_ACCOUNT_REASONS_LOADING = 'CLOSE_ACCOUNT_REASONS_LOADING';
export const CLOSE_ACCOUNT_REASONS_LOADED = 'CLOSE_ACCOUNT_REASONS_LOADED';

export const CLOSE_ACCOUNT_FLAG = 'close_your_account_web';
export const CLOSE_ACCOUNT_CONTENTFUL_KEY = 'componentSettingRowItem';
export const CLOSE_ACCOUNT_CONTENTFUL_TITLE = 'CLOSE_ACCOUNT';
export const ACCOUNT_CLOSED_LS_KEY = 'ACCOUNT_CLOSED';

export const WALLET_BALANCE_MIN_WITHDRAWAL_AMOUNT = 1;

/** Account-closure blocked HTTP status in 200 response body (ICBE-4987) */
export const ACCOUNT_CLOSURE_BLOCKED_STATUS_CODE = 463;

export const CLOSURE_ERROR_CODES = {
  AML_HIT: 'AML_HIT',
  NEGATIVE_WALLET_BALANCE: 'NEGATIVE_WALLET_BALANCE',
  TRANSFER_IN_PROGRESS: 'TRANSFER_IN_PROGRESS',
  WITHDRAW_BALANCE: 'WITHDRAW_BALANCE',
  ADD_FUNDS_TO_WITHDRAW: 'ADD_FUNDS_TO_WITHDRAW',
  UNSETTLED_AMAZE_TXN: 'UNSETTLED_AMAZE_TXN'
} as const;
